<template>
  <avs-card
    class="fill-height"
    noTitle
  >
    <template v-slot:content>
      <v-list-item
        class="fill-height"
        :to="to"
      >
        <v-list-item-content>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="secondary--text text-h5 font-weight-bold title-wrapping"
                >{{ title }}
              </span>
            </template>
            <span>{{ title }}</span>
          </v-tooltip>

          <span class="ml-2 primary--text text-h3 font-weight-bold">
            {{ value }}<Overdue v-if="isOverdue" />
          </span>
        </v-list-item-content>

        <v-list-item-avatar
          :size="avatarSize"
          right
          tile
          :class="avatarClass"
        >
          <v-img :src="img" />
        </v-list-item-avatar>
      </v-list-item>
    </template>
  </avs-card>
</template>

<script>
import { Overdue } from "@/components/generics/status"
export default {
  components: {
    Overdue
  },
  props: {
    avatarClass: {
      type: String,
      default: ""
    },
    avatarSize: {
      type: String,
      default: "100"
    },
    img: {
      type: String
    },
    isOverdue: {
      type: Boolean,
      default: false
    },
    quantity: {
      type: Number,
      default: 0
    },
    quantityUnit: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    to: {
      type: Object
    }
  },

  data() {
    return {}
  },
  computed: {
    value() {
      return isNaN(this.quantity) ? "-" : `${this.quantity} ${this.quantityUnit}`
    }
  }
}
</script>

<style lang="scss" scoped>
span.title-wrapping {
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: normal;
}
</style>
